import React, { Component } from 'react';
import {retrieveAllBackups, restore} from "../../util/ApiUtils";
import {Route} from "react-router-dom";

class Backup extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fileNames: [],
            message: null
        };
        this.findAllBackups = this.findAllBackups.bind(this);
        this.loadBackupData = this.loadBackupData.bind(this);
    }

    componentDidMount() {
        this.findAllBackups();
    }

    loadBackupData(fileName) {
        console.log("nothing for now", fileName);
        restore(fileName);
    }

    findAllBackups() {
        retrieveAllBackups()
            .then(
                response => {
                    console.log(response);
                    this.setState({ fileNames: response })
                }
            )
    }

    render() {
        return (
            <Route path={`/backup` }>
            <div className="container" style={{ textAlign: "center" }}>
                <h3>All Backups</h3>
                <div className="container">
                    <table className="table" style={{ marginLeft: "auto", marginRight: "auto" }}>
                        <thead>
                        <tr>
                            <th>Backup File Name</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            this.state.fileNames.map(
                                fileName =>
                                    <tr>
                                        <td><a href="#" onClick={ () => this.loadBackupData(fileName) }>{fileName}</a></td>
                                    </tr>
                            )
                        }
                        </tbody>
                    </table>
                </div>
            </div>
            </Route>
        )
    }
}

export default Backup;